var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfrastructure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.99951 7.99744H45.9861",
    stroke: "#A3AED0",
    strokeWidth: 5.99817
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9948 10.9965V30.9904",
    stroke: "#A3AED0",
    strokeWidth: 3.99878
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9905 10.9965V30.9903H39.9878V41.987H7.99756V43.9864V30.9903H18.9942",
    stroke: "#A3AED0",
    strokeWidth: 3.99878
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24 8.99963L16 16.9996",
    stroke: "#A3AED0",
    strokeWidth: 0.799756
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28 8.99963L18 18.9996",
    stroke: "#A3AED0",
    strokeWidth: 0.799756
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M34 30.9996L24 40.9996",
    stroke: "#A3AED0",
    strokeWidth: 0.799756
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M40 36.9998L34 42.9998",
    stroke: "#A3AED0",
    strokeWidth: 0.799756
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M40 32.9999L30 42.9999",
    stroke: "#A3AED0",
    strokeWidth: 0.799756
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M38 30.9996L28 40.9996",
    stroke: "#A3AED0",
    strokeWidth: 0.799756
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M30 30.9996L20 40.9996",
    stroke: "#A3AED0",
    strokeWidth: 0.799756
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M30 26.9998L16 40.9998",
    stroke: "#A3AED0",
    strokeWidth: 0.799756
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M30 23L10 43",
    stroke: "#A3AED0",
    strokeWidth: 0.799756
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M18 30.9996L8 40.9996",
    stroke: "#A3AED0",
    strokeWidth: 0.799756
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M16 28.9996L8 36.9996",
    stroke: "#A3AED0",
    strokeWidth: 0.799756
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M30 18.9999L18 30.9999",
    stroke: "#A3AED0",
    strokeWidth: 0.799756
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M32 12.9999L18 26.9999",
    stroke: "#A3AED0",
    strokeWidth: 0.799756
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M30 10.9999L18 22.9999",
    stroke: "#A3AED0",
    strokeWidth: 0.799756
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfrastructure);
export default __webpack_public_path__ + "static/media/Infrastructure.2445b95b31e3b12c58677cbeb54eca50.svg";
export { ForwardRef as ReactComponent };